import products from "./products";
import modalSlice from "../modal/modal-slice";

export default {
    products,
    modal: modalSlice.reducer,
};
